import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Sparkles, Eye, Camera, Heart, Users, MessageCircle, Star, Award, Crown, CheckCircle, Play, Mic, Globe } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ScrollProgress';
import { LanguageProvider } from '../context/LanguageContext';
export function InfluencersPage() {
  return <LanguageProvider data-id="element-4409" data-mp="2br5b5yr1lyw9">
      <div className="relative bg-black text-white overflow-x-hidden" data-id="element-4410" data-mp="2fqmi6wm4b43j">
        <ScrollProgress data-id="element-4411" data-mp="2fsqv241zvdfy" />
        <Navbar data-id="element-4412" data-mp="2kppo0j9x9eck" />
        <main className="w-full" data-id="element-4413" data-mp="2kq8wl9domqdx">
          <InfluencerHero data-id="element-4414" data-mp="2krajcb4291bh" />
          <WhyHostSection data-id="element-4415" data-mp="2kncwbeed3pmb" />
          <ContentOpportunitiesSection data-id="element-4416" data-mp="3r6b4dlrjrz3a" />
          <CollaborationPackagesSection data-id="element-4417" data-mp="3r59rrcuvv4jg" />
          <ExperienceDetailsSection data-id="element-4418" data-mp="3w4w3tiyz6eqo" />
          <SocialProofSection data-id="element-4419" data-mp="3w3uvhm9cg6cn" />
          <InfluencerCTA data-id="element-4420" data-mp="3w31m0dj032qt" />
        </main>
        <Footer data-id="element-4421" data-mp="1746fetkpyivr" />
      </div>
    </LanguageProvider>;
}
function InfluencerHero() {
  return <section className="relative w-full min-h-screen bg-black flex items-center justify-center overflow-hidden" data-id="element-4422" data-mp="125mqqleqqszp">
      <div className="absolute inset-0" data-id="element-4423" data-mp="x5h4xlv5k0pj">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxKq2k9j3qcBE1TheAWARz/Experience_image.png" alt="Life in the Sikh Kingdoms" className="w-full h-full object-cover opacity-30" data-id="element-4424" data-mp="x4fhsj0v3nrg" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" data-id="element-4425" data-mp="jevg7gj0owjq"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-4426" data-mp="ef95bdqnvse3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} data-id="element-4427" data-mp="edfvjpkr4s1v">
          <Link to="/" className="inline-flex items-center gap-2 text-amber-400/70 hover:text-amber-400 text-sm tracking-wider uppercase font-light mb-12 transition-colors" data-id="element-4428" data-mp="gt0jscd0byl">
            <ArrowLeft className="w-4 h-4" data-id="element-4429" data-mp="3qxa7n545u8uu" />
            Back to Life in the Sikh Kingdoms
          </Link>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-4430" data-mp="3hyf1tu5130s2">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6 font-light" data-id="element-4431" data-mp="dmkybnwrq5zm">
            Presented by Akal Steel
          </p>
          <p className="text-amber-400 tracking-[0.3em] text-xs md:text-sm uppercase mb-8 font-light" data-id="element-4432" data-mp="4rmzy1auq10w">
            Host an Exclusive Experience
          </p>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-8 tracking-tight leading-none" data-id="element-4433" data-mp="sfo6j4ogz7do">
            HOST AN
            <br data-id="element-4434" data-mp="16mrfs3e9qhgs" />
            <span className="text-amber-400" data-id="element-4435" data-mp="16m7ymowfzx3t">EXPERIENCE</span>
          </h1>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-4436" data-mp="12lxvrl3y5mt6"></div>
          <p className="text-xl md:text-2xl text-white/70 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-4437" data-mp="12jv4kxr25nmv">
            Create Unforgettable Content at the Intersection of Culture, Cuisine
            &amp; Immersive Art
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-8 text-white/60" data-id="element-4438" data-mp="npghom4dhu2x">
          <div className="text-center" data-id="element-4439" data-mp="2918ihglucg6i">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-4440" data-mp="2906te87zpt5s">
              360°
            </p>
            <p className="font-serif text-xl text-white" data-id="element-4441" data-mp="244rjtsh0mjf6">Immersive</p>
            <p className="text-xs font-light" data-id="element-4442" data-mp="dmuyrdc5lbpw">Projections</p>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20" data-id="element-4443" data-mp="ijutwt7gsu28"></div>
          <div className="text-center" data-id="element-4444" data-mp="njqxwsg5wlhs">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-4445" data-mp="nio7elmr4l2e">
              Royal
            </p>
            <p className="font-serif text-xl text-white" data-id="element-4446" data-mp="rmvyuqklgf4b">Punjabi</p>
            <p className="text-xs font-light" data-id="element-4447" data-mp="wl7an6ug8zp6">Cuisine</p>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20" data-id="element-4448" data-mp="11jijbe90d45t"></div>
          <div className="text-center" data-id="element-4449" data-mp="11hnuhoum8rwg">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-4450" data-mp="169p5l7g1sckw">
              200+
            </p>
            <p className="font-serif text-xl text-white" data-id="element-4451" data-mp="1b9ldvivs2q69">Years of</p>
            <p className="text-xs font-light" data-id="element-4452" data-mp="1fax0rgn9oxar">Sikh Heritage</p>
          </div>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-4453" data-mp="1k9gqzt8w8v8x">
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-white/50 to-transparent" data-id="element-4454" data-mp="2zrednv22a54z"></div>
      </motion.div>
    </section>;
}
function WhyHostSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4455" data-mp="3jhqde30swmwy">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-4456" data-mp="39rx2l48hgbtr"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-4457" data-mp="b1dgibwgwv3z">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-4458" data-mp="b2ye6ae2wu62">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-4459" data-mp="gdaf9yc1wyy8">
            Why This Experience
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-4460" data-mp="ke43ksteofrn">
            WHY <span className="text-amber-400" data-id="element-4461" data-mp="6ekyk8vw5kjk">HOST HERE</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-4462" data-mp="bfipb9uyvmwo"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-4463" data-mp="3tkvj8eu8s017">
            Life in the Sikh Kingdoms is unlike any venue you've hosted in
            before. It's a living, breathing world — and your audience will feel
            every second of it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-4464" data-mp="1vvm1hbob2l69">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-4465" data-mp="3gcv8sxkynkp6">
            <Camera className="w-8 h-8 text-amber-400 mb-4" data-id="element-4466" data-mp="3uoow0zcunei" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-4467" data-mp="3v2ax86x0re1p">
              Unmatched Visual Content
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-4468" data-mp="cwo5wtaddrhg">
              360° immersive projections, royal cuisine, and interactive
              technology create content that stops the scroll. Every corner of
              this experience is a frame-worthy moment — from the sensory
              battlefield to the royal court audience.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-4469" data-mp="1otjsmf0rgfus">
            <Star className="w-8 h-8 text-amber-400 mb-4" data-id="element-4470" data-mp="15vqq3du1u7xx" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-4471" data-mp="19v7vk79h7533">
              Exclusive Access
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-4472" data-mp="1etsum3czripy">
              Behind-the-scenes creator previews, private photo moments, and
              early access to the experience before public launch. You'll have
              content no one else has — and the story to match.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-4473" data-mp="2v79bfuagadxl">
            <Mic className="w-8 h-8 text-amber-400 mb-4" data-id="element-4474" data-mp="uzi9irclxv2" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-4475" data-mp="wkbn51xfarc">
              Authentic Storytelling
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-4476" data-mp="3s3wudoigjw9d">
              Connect your audience with 200+ years of Sikh heritage through
              taste, sight, sound, and storytelling. This isn't a sponsored post
              — it's a genuine cultural journey your community will thank you
              for sharing.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-4477" data-mp="1gcj7phy9rgb8">
            <Heart className="w-8 h-8 text-amber-400 mb-4" data-id="element-4478" data-mp="3c1vg2lgle4k2" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-4479" data-mp="3c2dm29t23x56">
              Community Engagement
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-4480" data-mp="370xx46nrd6hi">
              Align with cultural preservation, youth education, and
              multicultural excellence. A portion of proceeds supports the Sikh
              Art and Culture Gallery at the ROM — giving your audience a reason
              to feel good about attending.
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function ContentOpportunitiesSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4481" data-mp="yuw37ewdfbgn">
      <div className="container mx-auto px-4" data-id="element-4482" data-mp="1mljco4lxq95b">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-4483" data-mp="1rkcs42ks8a84">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-4484" data-mp="23lf6ndexgr4">
            What You'll Capture
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-4485" data-mp="28t5kd1h042s1">
            CONTENT <span className="text-amber-400" data-id="element-4486" data-mp="28v8cbr1ps5ze">OPPORTUNITIES</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-4487" data-mp="23ukhsvea170f"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light" data-id="element-4488" data-mp="1z2an7227virt">
            Three distinct content worlds, each more extraordinary than the
            last.
          </p>
        </motion.div>

        <div className="max-w-6xl mx-auto space-y-8" data-id="element-4489" data-mp="1q3pahnjfexyy">
          {/* Immersive Projections */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="grid grid-cols-1 lg:grid-cols-2 gap-0 border-2 border-amber-400/30 overflow-hidden" data-id="element-4490" data-mp="1l2jcba6zyii1">
            <div className="aspect-video lg:aspect-auto relative" data-id="element-4491" data-mp="35hlelav230bh">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rru8mxg1f864Swgj1TtDBp/Gemini_Generated_Image_xf598lxf598lxf59.png" alt="Royal Procession" className="w-full h-full object-cover" data-id="element-4492" data-mp="3dzx1q3bcgzk1" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/40" data-id="element-4493" data-mp="3rs35sr183g34"></div>
            </div>
            <div className="p-8 md:p-10 bg-black/60 flex flex-col justify-center" data-id="element-4494" data-mp="2v2vvyg9yuvf1">
              <div className="flex items-center gap-3 mb-4" data-id="element-4495" data-mp="2z2e5yh091m33">
                <Eye className="w-6 h-6 text-amber-400" data-id="element-4496" data-mp="2z4z691kwftyq" />
                <p className="text-amber-400 text-xs tracking-[0.2em] uppercase font-light" data-id="element-4497" data-mp="341hck5vvo0d6">
                  Visual Content
                </p>
              </div>
              <h3 className="font-serif text-3xl text-white mb-4" data-id="element-4498" data-mp="jcjgu47l4jtv">
                360° Immersive Projections
              </h3>
              <p className="text-white/70 font-light leading-relaxed mb-4" data-id="element-4499" data-mp="o9teu891i3tb">
                Maharaja Ranjit Singh's royal procession, the Khalsa cavalry,
                twilight at the palace — all rendered in breathtaking 360°
                projection across walls, floors, and tables. Every angle is a
                hero shot.
              </p>
              <div className="space-y-2" data-id="element-4500" data-mp="219mvh27o31jg">
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4501" data-mp="218vaelbp4m7f">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4502" data-mp="2g5vrzw06b0s6"></span>
                  Royal procession visuals
                </div>
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4503" data-mp="2b5q6kxkhyaij">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4504" data-mp="2oyfxngevu5mi"></span>
                  Khalsa army panoramas
                </div>
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4505" data-mp="2yx5cf0bhf9yj">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4506" data-mp="2tykcz3420ub5"></span>
                  Palace architecture &amp; twilight scenes
                </div>
              </div>
            </div>
          </motion.div>

          {/* Culinary Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="grid grid-cols-1 lg:grid-cols-2 gap-0 border-2 border-amber-400/30 overflow-hidden" data-id="element-4507" data-mp="3iiosryk551me">
            <div className="p-8 md:p-10 bg-black/60 flex flex-col justify-center order-2 lg:order-1" data-id="element-4508" data-mp="2kvoryhmi8265">
              <div className="flex items-center gap-3 mb-4" data-id="element-4509" data-mp="2pu9oo72js3pu">
                <Crown className="w-6 h-6 text-amber-400" data-id="element-4510" data-mp="2psf4ww30ihnc" />
                <p className="text-amber-400 text-xs tracking-[0.2em] uppercase font-light" data-id="element-4511" data-mp="2bvt8zqmpj2vk">
                  Food Content
                </p>
              </div>
              <h3 className="font-serif text-3xl text-white mb-4" data-id="element-4512" data-mp="mdmne385xtgf">
                Royal Punjabi Cuisine
              </h3>
              <p className="text-white/70 font-light leading-relaxed mb-4" data-id="element-4513" data-mp="hmmq2wv4t9de">
                Historically researched dishes from Maharaja Ranjit Singh's
                court — styled, plated, and served in an immersive setting. Chef
                interactions, dish reveals, and the story behind every course.
              </p>
              <div className="space-y-2" data-id="element-4514" data-mp="15byxpsat99dl">
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4515" data-mp="10de5og5ppw08">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4516" data-mp="10bkvwrzsyvo0"></span>
                  Styled royal dish reveals
                </div>
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4517" data-mp="rbo5olxrloqu">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4518" data-mp="3g4saoig4f7ap"></span>
                  Chef interactions &amp; behind-the-scenes
                </div>
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4519" data-mp="3c5b3nkl1q23f">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4520" data-mp="1ritbdirxhdc5"></span>
                  5–7 course immersive dining journey
                </div>
              </div>
            </div>
            <div className="aspect-video lg:aspect-auto relative order-1 lg:order-2" data-id="element-4521" data-mp="20k9kzoax5bfb">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2zSbggEuZfU5JNU7W478R9/Gemini_Generated_Image_36dj2y36dj2y36dj.png" alt="Royal Cuisine" className="w-full h-full object-cover" data-id="element-4522" data-mp="25dvlki3t5our" />
              <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black/40" data-id="element-4523" data-mp="2jbk59mm52py8"></div>
            </div>
          </motion.div>

          {/* Interactive Moments */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="grid grid-cols-1 lg:grid-cols-2 gap-0 border-2 border-amber-400/30 overflow-hidden" data-id="element-4524" data-mp="oy2k2697i56d">
            <div className="aspect-video lg:aspect-auto relative" data-id="element-4525" data-mp="35j67i3yfrrdk">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7baikykwbzRgddsVg9e56P/Gemini_Generated_Image_k59hd9k59hd9k59h.png" alt="Interactive Experience" className="w-full h-full object-cover" data-id="element-4526" data-mp="30kwb5q0z6kqd" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/40" data-id="element-4527" data-mp="2mtzu8wgevrz5"></div>
            </div>
            <div className="p-8 md:p-10 bg-black/60 flex flex-col justify-center" data-id="element-4528" data-mp="2hv6ib8grw913">
              <div className="flex items-center gap-3 mb-4" data-id="element-4529" data-mp="23sbr1qpupoi">
                <Play className="w-6 h-6 text-amber-400" data-id="element-4530" data-mp="227h7c4ej6qn" />
                <p className="text-amber-400 text-xs tracking-[0.2em] uppercase font-light" data-id="element-4531" data-mp="3talbs29rwirg">
                  Interactive Moments
                </p>
              </div>
              <h3 className="font-serif text-3xl text-white mb-4" data-id="element-4532" data-mp="1f4ndyu3zjsam">
                Sensory &amp; Interactive Technology
              </h3>
              <p className="text-white/70 font-light leading-relaxed mb-4" data-id="element-4533" data-mp="162e7cfbu8j2i">
                Voice-activated royal court audiences, sensory battlefields with
                scent triggers and spatial audio, soaring eagle perspectives —
                moments your audience will watch on repeat.
              </p>
              <div className="space-y-2" data-id="element-4534" data-mp="22qliug739h2u">
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4535" data-mp="22tpt9vb5d91y">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4536" data-mp="1oydxrlp63ejz"></span>
                  Sensory battlefield experience
                </div>
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4537" data-mp="2hovyig2f53u8">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4538" data-mp="2mg4b1kz1p5bm"></span>
                  Voice-activated royal court audience
                </div>
                <div className="flex items-center gap-2 text-white/50 text-sm font-light" data-id="element-4539" data-mp="32rg81znqhl6m">
                  <span className="w-1 h-1 rounded-full bg-amber-400" data-id="element-4540" data-mp="37nohcwf92k5v"></span>
                  Soaring eagle perspectives
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function CollaborationPackagesSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4541" data-mp="2ez968kz8olzt">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-4542" data-mp="97m0sys90fwa"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-4543" data-mp="d7mm93drlrcu">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-4544" data-mp="1xpov9buiuq71">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-4545" data-mp="22ngms4r98aap">
            How We Work Together
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-4546" data-mp="2cfw1mt798ird">
            COLLABORATION <span className="text-amber-400" data-id="element-4547" data-mp="2qevqo1yoizo2">PACKAGES</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-4548" data-mp="2qd1d58pqm9u0"></div>
          <p className="text-white/70 font-light max-w-2xl mx-auto" data-id="element-4549" data-mp="2lgkg1p0k8l4s">
            From intimate creator previews to full cultural ambassador
            partnerships, we have a collaboration that fits your vision.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-4550" data-mp="2r49djn9bvyff">
          {/* Creator Preview */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0
        }} data-id="element-4551" data-mp="2w2ubth50s818">
            <div className="border-2 border-amber-400/30 bg-black/80 p-8 h-full flex flex-col" data-id="element-4552" data-mp="3a1arhxkv18vi">
              <div className="text-center mb-6" data-id="element-4553" data-mp="3ezvhz5ab8e6r">
                <Camera className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-4554" data-mp="3jtzs1xevh2c2" />
                <h3 className="font-serif text-2xl text-white mb-1" data-id="element-4555" data-mp="3osjdlwpk0c3w">
                  Creator Preview
                </h3>
                <p className="text-amber-400/60 text-xs tracking-wider uppercase font-light" data-id="element-4556" data-mp="3suo4inomaumu">
                  Early Access
                </p>
                <div className="w-12 h-px bg-amber-400/30 mx-auto mt-3" data-id="element-4557" data-mp="1kz6jytpqcvg"></div>
              </div>
              <ul className="space-y-3 flex-grow" data-id="element-4558" data-mp="1m2zy5zeilnpc">
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4559" data-mp="1h58717lp25m7">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4560" data-mp="1d468yu3ijzlt"></span>
                  Early access preview night before public launch
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4561" data-mp="24wdn9nvjqzx1">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4562" data-mp="20u8t8o16s19v"></span>
                  Behind-the-scenes content creation time
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4563" data-mp="1w17ceahf5rnn">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4564" data-mp="1r479g8fv950r"></span>
                  2 complimentary tickets
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4565" data-mp="2js39nn4n9f2a">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4566" data-mp="23dca9qyvwt9g"></span>
                  Social media cross-promotion
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4567" data-mp="1ucxetys7hxs8">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4568" data-mp="1ufa28rgqh0co"></span>
                  Digital press kit &amp; assets
                </li>
              </ul>
              <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20a%20Creator%20Preview%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="mt-8 w-full border border-amber-400/50 hover:bg-amber-400 hover:text-black text-white py-3 text-center text-sm tracking-wider uppercase font-light transition-all duration-300 block" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-4569" data-mp="2n3pdd2wquyiq">
                Apply Now
              </motion.a>
            </div>
          </motion.div>

          {/* Experience Host */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="relative" data-id="element-4570" data-mp="3tuqz0hdst2x5">
            <div className="absolute top-0 left-0 right-0 flex justify-center z-30 transform -translate-y-1/2" data-id="element-4571" data-mp="3b6c7zu3hdowc">
              <div className="bg-amber-400 text-black font-bold py-2 px-6 flex items-center gap-2" data-id="element-4572" data-mp="365g8dsq5wowq">
                <Star className="w-4 h-4" fill="currentColor" data-id="element-4573" data-mp="qdsek66g3ci5" />
                <span className="text-xs uppercase tracking-wider" data-id="element-4574" data-mp="lgielwlfjig2">
                  Most Popular
                </span>
              </div>
            </div>
            <div className="border-2 border-amber-400 bg-black/80 p-8 pt-12 h-full flex flex-col" data-id="element-4575" data-mp="tirdvtfo4fc5">
              <div className="text-center mb-6" data-id="element-4576" data-mp="xkcvtt727jt7">
                <Users className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-4577" data-mp="12h3dgkyiingq" />
                <h3 className="font-serif text-2xl text-white mb-1" data-id="element-4578" data-mp="17g7kp61vmb4f">
                  Experience Host
                </h3>
                <p className="text-amber-400/60 text-xs tracking-wider uppercase font-light" data-id="element-4579" data-mp="9tgzqjvkm2g5">
                  Private Table
                </p>
                <div className="w-12 h-px bg-amber-400/30 mx-auto mt-3" data-id="element-4580" data-mp="eppjybomklu6"></div>
              </div>
              <ul className="space-y-3 flex-grow" data-id="element-4581" data-mp="jose3132h7nd">
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4582" data-mp="ohv8fbfo4l4m">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4583" data-mp="3n7vif3ops7oa"></span>
                  Private hosted table for your community (10 guests)
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4584" data-mp="3kmw1hdajsvh5">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4585" data-mp="3fo2yiesw0mv8"></span>
                  Dedicated content creation time &amp; access
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4586" data-mp="3aqt0wbvch4wb">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4587" data-mp="35pn3w1univgz"></span>
                  Professional photography of your experience
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4588" data-mp="2ww0b8klqq8c0">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4589" data-mp="2rz9z28d23wvv"></span>
                  Featured in event social media channels
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4590" data-mp="2i0kj4l4q0mi9">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4591" data-mp="2dy7c7te8mijw"></span>
                  Custom branded moment at the event
                </li>
              </ul>
              <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20hosting%20an%20influencer%20event%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="mt-8 w-full bg-amber-400 hover:bg-amber-500 text-black py-3 text-center text-sm tracking-wider uppercase font-medium transition-colors duration-300 block" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-4592" data-mp="apnj4wu02g9m">
                Apply Now
              </motion.a>
            </div>
          </motion.div>

          {/* Cultural Ambassador */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-4593" data-mp="306l4ny4nf9bs">
            <div className="border-2 border-amber-400/30 bg-black/80 p-8 h-full flex flex-col" data-id="element-4594" data-mp="2ukaud6qheve6">
              <div className="text-center mb-6" data-id="element-4595" data-mp="2pkohwzih9j6f">
                <Globe className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-4596" data-mp="2pn2bf3xienbv" />
                <h3 className="font-serif text-2xl text-white mb-1" data-id="element-4597" data-mp="34gxcvovc5ad1">
                  Cultural Ambassador
                </h3>
                <p className="text-amber-400/60 text-xs tracking-wider uppercase font-light" data-id="element-4598" data-mp="2zh17pmawjcvw">
                  Full Partnership
                </p>
                <div className="w-12 h-px bg-amber-400/30 mx-auto mt-3" data-id="element-4599" data-mp="398oz5n7gktxd"></div>
              </div>
              <ul className="space-y-3 flex-grow" data-id="element-4600" data-mp="3n7x0omr3ge4q">
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4601" data-mp="3n6lrg7evqe68">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4602" data-mp="3ibg9fjolljnf"></span>
                  All Experience Host benefits included
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4603" data-mp="36qfs7bho2233">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4604" data-mp="31oyvzta4n3su"></span>
                  Multi-event access (May–Dec 2026)
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4605" data-mp="2rsdq75qa9ony">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4606" data-mp="2n15cvylu1j5i"></span>
                  Co-branded content series opportunity
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4607" data-mp="2ix61fufetaj0">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4608" data-mp="2e2a8ms2cmj4u"></span>
                  Input into future cultural experiences
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4609" data-mp="242t6gkmb2ndm">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4610" data-mp="1txb5ety3j3ed"></span>
                  Recognition as Cultural Ambassador
                </li>
              </ul>
              <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20becoming%20a%20Cultural%20Ambassador%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="mt-8 w-full border border-amber-400/50 hover:bg-amber-400 hover:text-black text-white py-3 text-center text-sm tracking-wider uppercase font-light transition-all duration-300 block" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-4611" data-mp="23xk4cfjh32xg">
                Apply Now
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function ExperienceDetailsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4612" data-mp="u6qwaotu0nuc">
      <div className="container mx-auto px-4" data-id="element-4613" data-mp="6h4vjwxta0k8">
        <div className="max-w-5xl mx-auto" data-id="element-4614" data-mp="1ibho3em47jj">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="border-2 border-amber-400/40 p-8 md:p-12 bg-gradient-to-br from-amber-950/20 to-black/60" data-id="element-4615" data-mp="1jcxel6kpi7l">
            <div className="text-center mb-10" data-id="element-4616" data-mp="1ue4br4otn1mm">
              <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-4" data-id="element-4617" data-mp="1udcgjuz4z5wv">
                Event Details
              </p>
              <h2 className="font-serif text-4xl text-white mb-4" data-id="element-4618" data-mp="1le8uqj8l4ceo">
                The <span className="text-amber-400" data-id="element-4619" data-mp="1lg26ue1yvou2">Experience</span>
              </h2>
              <div className="w-16 h-px bg-amber-400/30 mx-auto" data-id="element-4620" data-mp="1pfugyv70e31j"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10" data-id="element-4621" data-mp="2d5os98bojjjo">
              <div className="text-center border-l-2 border-amber-400/30 pl-6" data-id="element-4622" data-mp="2i4hvm7x95u64">
                <p className="text-amber-400 text-xs tracking-wider uppercase mb-2" data-id="element-4623" data-mp="24d3ek6mwo31p">
                  Venue
                </p>
                <p className="font-serif text-xl text-white mb-1" data-id="element-4624" data-mp="28ddjdfyyonez">
                  Illuminarium Toronto
                </p>
                <p className="text-white/50 text-sm font-light" data-id="element-4625" data-mp="2w2q0d20j5zru">Toronto, ON</p>
              </div>
              <div className="text-center border-l-2 border-amber-400/30 pl-6" data-id="element-4626" data-mp="30w0y8dnd767m">
                <p className="text-amber-400 text-xs tracking-wider uppercase mb-2" data-id="element-4627" data-mp="1d77fwj9v3b5i">
                  When
                </p>
                <p className="font-serif text-xl text-white mb-1" data-id="element-4628" data-mp="189ee02fld3b1">
                  Summer 2026
                </p>
                <p className="text-white/50 text-sm font-light" data-id="element-4629" data-mp="z6my9qfonldl">
                  Monthly May–Dec 2026
                </p>
              </div>
              <div className="text-center border-l-2 border-amber-400/30 pl-6" data-id="element-4630" data-mp="1vvukl0o4lyik">
                <p className="text-amber-400 text-xs tracking-wider uppercase mb-2" data-id="element-4631" data-mp="1qxb074p6kusb">
                  Format
                </p>
                <p className="font-serif text-xl text-white mb-1" data-id="element-4632" data-mp="1m5jg9d0j5nb5">90 Minutes</p>
                <p className="text-white/50 text-sm font-light" data-id="element-4633" data-mp="1i4g16sqb3vaz">
                  Immersive Dining
                </p>
              </div>
            </div>
            <div className="text-center pt-8 border-t border-white/10" data-id="element-4634" data-mp="2ep85ecy4kokg">
              <p className="text-xl text-amber-400 italic font-light" data-id="element-4635" data-mp="29vdr5p1ah1sr">
                "Step inside a living, breathing version of the Sikh Kingdoms —
                where you don't just see history, you experience it."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function SocialProofSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4636" data-mp="k9vjnxj78oit">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-4637" data-mp="t38jljfokqee"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-4638" data-mp="y462xzcffqhh">
        <div className="max-w-4xl mx-auto" data-id="element-4639" data-mp="y1jwk319vh0u">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-16" data-id="element-4640" data-mp="133iwt41ptxtk">
            <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-4641" data-mp="344ffdbhnbw6q">
              The Legacy Behind the Experience
            </p>
            <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-4642" data-mp="3hy6qgob0zo4k">
              BUILT ON <span className="text-amber-400" data-id="element-4643" data-mp="3dtz2wugb0e7x">EXCELLENCE</span>
            </h2>
            <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-4644" data-mp="3rsyo1s4lyazc"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="border-2 border-amber-400/40 p-8 md:p-12 bg-gradient-to-br from-amber-950/20 to-black/60 mb-8" data-id="element-4645" data-mp="3mw88r70mnjez">
            <p className="text-2xl text-amber-400 font-light italic text-center leading-relaxed" data-id="element-4646" data-mp="3uepkzkzw1cbn">
              "This immersive experience honors the groundbreaking Art of the
              Sikh Kingdoms exhibition at the Royal Ontario Museum — the second
              most popular exhibition in ROM history."
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4647" data-mp="3qdvxgsqcxzja">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0
          }} className="border border-amber-400/30 p-6 text-center bg-black/40" data-id="element-4648" data-mp="3bgda9utbvudy">
              <Award className="w-8 h-8 text-amber-400 mx-auto mb-3" data-id="element-4649" data-mp="3tkj4c2qrmao3" />
              <h4 className="font-serif text-lg text-white mb-2" data-id="element-4650" data-mp="3tlazjcgga6du">
                Oscar-Winning Animators
              </h4>
              <p className="text-white/60 text-sm font-light" data-id="element-4651" data-mp="3juptx52d01lf">
                The team behind Lord of the Rings
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="border border-amber-400/30 p-6 text-center bg-black/40" data-id="element-4652" data-mp="3ex6hmap81yw4">
              <Star className="w-8 h-8 text-amber-400 mx-auto mb-3" data-id="element-4653" data-mp="z5inen1lekh0" />
              <h4 className="font-serif text-lg text-white mb-2" data-id="element-4654" data-mp="16o9ogla5wehs">
                Emmy-Winning Artists
              </h4>
              <p className="text-white/60 text-sm font-light" data-id="element-4655" data-mp="1bm1hxjqgg8o3">
                Creative minds behind Hasbro's global installations
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="border border-amber-400/30 p-6 text-center bg-black/40" data-id="element-4656" data-mp="1lcmobtcdehhk">
              <Crown className="w-8 h-8 text-amber-400 mx-auto mb-3" data-id="element-4657" data-mp="12k238y2wxgob" />
              <h4 className="font-serif text-lg text-white mb-2" data-id="element-4658" data-mp="29279mivzxqu0">
                HBO Producer
              </h4>
              <p className="text-white/60 text-sm font-light" data-id="element-4659" data-mp="2e3o8y9yu158h">
                Game of Thrones production pedigree
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>;
}
function InfluencerCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4660" data-mp="2rx0eo93bdtgb">
      <div className="container mx-auto px-4" data-id="element-4661" data-mp="31pxs40tg8s82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-4662" data-mp="31r8ubw78xrx2">
          <Sparkles className="w-10 h-10 text-amber-400 mx-auto mb-6" data-id="element-4663" data-mp="1423npj5muhhl" />
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-6" data-id="element-4664" data-mp="zzh425j482vh">
            Ready to Create Something{' '}
            <span className="text-amber-400" data-id="element-4665" data-mp="v1f9ancbuf46">Extraordinary?</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-4666" data-mp="q2cerwtz3rag"></div>
          <p className="text-xl text-white/70 font-light mb-10 leading-relaxed" data-id="element-4667" data-mp="1npbe6fc1vdc1">
            We're looking for creators who are passionate about culture,
            heritage, and authentic storytelling. Let's build something your
            audience will remember.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-4668" data-mp="1dxf3m4ss1uqx">
            <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20hosting%20an%20influencer%20event%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-amber-400 hover:bg-amber-500 text-black px-8 py-4 font-medium tracking-wider uppercase text-sm transition-colors duration-300" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-4669" data-mp="18zvqx9bq9q13">
              <MessageCircle className="w-5 h-5" data-id="element-4670" data-mp="3r4deobtj18f5" />
              Apply via WhatsApp
            </motion.a>
            <Link to="/" className="inline-flex items-center justify-center gap-2 border-2 border-amber-400/50 hover:border-amber-400 text-white hover:text-amber-400 px-8 py-4 font-light tracking-wider uppercase text-sm transition-all duration-300" data-id="element-4671" data-mp="3cb1st0xvoxou">
              <ArrowLeft className="w-4 h-4" data-id="element-4672" data-mp="387lzadh3vdgd" />
              Back to Main Site
            </Link>
          </div>
          <p className="text-white/40 text-sm font-light mt-6" data-id="element-4673" data-mp="11et6lolksky8">
            Our team will respond within 24 hours to discuss collaboration
            opportunities.
          </p>
        </motion.div>
      </div>
    </motion.section>;
}